import React, { Component } from "react";
import moment from 'moment'
import formatDate from 'intl-dateformat'

class StandardClockPreview extends Component {
    componentDidMount() {
        this.onUpdateShowTime();
    }
    componentWillUnmount() {
        clearInterval(this.timerID);
    }
    showTime = () => {
        const { timeZoneValue, timeFormat, isSecond, isDate } = this.props;
        const zoneDate = new Date()
        var nowDate = formatDate(zoneDate, 'YYYY/MM/DD hh:mm:ss A', { timezone: timeZoneValue })
        var date = new Date(nowDate);
        var h = date.getHours(); // 0 - 23
        var m = date.getMinutes(); // 0 - 59
        var s = date.getSeconds(); // 0 - 59
        var session = "AM";
        if (timeFormat == 0) {

            if (h == 0) {
                h = 12;
            }

            if (h >= 12) {
                h = h % 12;
                session = "PM";
            }
        }

        h = (h < 10) ? "0" + h : h;
        m = (m < 10) ? "0" + m : m;
        s = (s < 10) ? "0" + s : s;
        var time = h + ":" + m;
        if (isSecond) {
            time += ":" + s + " ";
        }

        if (timeFormat == 0) {
            time += `<span  class="cdtd_clock_timeType">${session}</span>`
        }
        if (time && document.getElementById("cdtd_clock_time")) {
            document.getElementById("cdtd_clock_card").style.display = "flex";

            document.getElementById("cdtd_clock_time").innerHTML = time;
        }

    }
    onUpdateShowTime = () => {
        this.timerID = setInterval(() => this.showTime(), 1000);
    }

    render() {
        const { timeZoneValue, isDate, isBackground, selectedUrl, Background, textColor } = this.props;
        const date = new Date()
        var nowDate = formatDate(date, 'YYYY/MM/DD hh:mm:ss A', { timezone: timeZoneValue })

        const bgstyleImg = selectedUrl ? { backgroundImage: `url(${selectedUrl})`, display: 'none', color: `${textColor}!important` } : { height: '100%', display: 'none', color: `${textColor}!important` }
        const bgstyleColor = Background ? { backgroundColor: Background, display: 'none', color: `${textColor}!important` } : { height: '100%', display: 'none', color: `${textColor}!important` }
        const fontColor = { color: textColor }
        return <div className="cdtd_clock_card" id="cdtd_clock_card" style={isBackground ? bgstyleImg : bgstyleColor} >
            <div className={` ${isBackground === 1 ? 'cdtd_clock_overlay' : 'cdtd_clock_overlay_none'}`}></div>
            <div className="cdtd_clock_cardContent cdtd_clock_cardContent_type_Classic">
                <div className="cdtd_clock_time" id="cdtd_clock_time" style={fontColor}></div>
                <div className="cdtd_clock_Classic_DayDate">
                    <div className="cdtd_clock_Classic_Day" style={fontColor}>{moment(nowDate).format('dddd')}</div>
                    {isDate ? <div className="cdtd_clock_Classic_Date">
                        <div className="cdtd_clock_Classic_DateMonth" style={fontColor}>{moment(nowDate).format('MMMM')}</div>
                        <div className="cdtd_clock_Classic_DateYear" style={fontColor}>{moment(nowDate).format('DD,YYYY')}</div>
                    </div> : null}
                </div>
            </div>
        </div>
    }
}

export default StandardClockPreview
